export const PATHS = {
  auth: {
    checkout: '/checkout',
    login: '/login',
    otp: '/otp',
    register: '/cadastro',
    resetNewPassword: '/redefinir-senha/nova-senha',
    resetPassword: '/redefinir-senha',
    subscriptionStatus: '/status-assinatura',
  },
  consolidator: {
    comparator: '/minha-carteira/comparador',
    index: '/minha-carteira',
  },
  custom: {
    index: '/custom',
  },
  event: {
    index: '/eventos',
  },
  financialPlanning: {
    immobilized: '/planejamento-financeiro/imobilizado',
    index: '/planejamento-financeiro',
    myGoals: '/planejamento-financeiro/meus-objetivos',
    myRetirement: '/planejamento-financeiro/minha-aposentadoria',
    myWealth: '/planejamento-financeiro/meu-patrimonio',
    financialControl: '/planejamento-financeiro/controle-financeiro',
  },
  home: '/',
  welcome: '/bem-vindo',
  hubs: {
    advisory: '/minha-assessoria',
    author: '/autor',
    content: '/conteudo',
    courses: '/cursos',
    movies: '/filmes',
    privatePension: '/minha-previdencia',
    program: '/programa',
    recommendation: '/ativos-recomendados',
    research: '/research',
    researchProgram: '/research/programa',
  },
  indications: {
    flourish: '/programa-de-pontos',
  },
  lp: {
    business: '/empresarial',
    creditCard: '/cartao-de-credito',
    exchange: '/cambio',
    goodsAcquisiton: '/aquisicao-de-bens',
    lifeInsurance: '/seguro-vida',
    rvAdvisory: '/assessoria-renda-variavel',
  },
  news: {
    index: '/noticias',
  },
  investments: {
    index: '/investimentos',
  },
  profile: {
    updateData: '/atualizar-dados',
  },
  search: '/busca',
  user: {
    myHistoric: '/meu-historico',
    myList: '/minha-lista',
    profile: '/meu-perfil',
  },
};
